import { createFeatureSelector } from '@ngrx/store';
import * as fromJobTypes from './job-types.reducer';

export const selectJobTypeState =
  createFeatureSelector<fromJobTypes.JobTypeState>(
    fromJobTypes.jobTypesFeatureKey,
  );
